import { useEffect, useState } from "react";

export type ReferenceProject = {
    id: string;
    slug: string;
    title: string;
    subtitle: string | null;
    location: string | null;
    object_type: string | null;
    capture_date: string | null;
    cover_url: string | null;
    media_count: number;
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL as string;

/**
 * Fetch published + public projects (with cover) für Referenz-Sektionen.
 * Ergebnis wird gecached in-memory für die Session.
 */
export function useReferenceProjects(
    limit = 6,
    source: "all" | "main" | "sylt" = "all",
): { items: ReferenceProject[]; loading: boolean } {
    const [items, setItems] = useState<ReferenceProject[]>([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let cancelled = false;
        void (async () => {
            try {
                const path =
                    source === "main"
                        ? `/api/showcase/main?limit=${limit}`
                        : source === "sylt"
                            ? `/api/showcase/sylt?limit=${limit}`
                            : `/api/projects?limit=${limit}`;
                const res = await fetch(`${BACKEND_URL}${path}`, {
                    credentials: "omit",
                });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const data = await res.json();
                if (!cancelled) {
                    // Nur Projekte MIT Cover anzeigen (ohne Cover keine Karte)
                    setItems((data.items || []).filter((p: ReferenceProject) => p.cover_url));
                }
            } catch {
                if (!cancelled) setItems([]);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, [limit, source]);
    return { items, loading };
}

const MONTHS_DE = [
    "Januar", "Februar", "März", "April", "Mai", "Juni",
    "Juli", "August", "September", "Oktober", "November", "Dezember",
];

export function formatMonthYearDe(iso: string | null): string {
    if (!iso) return "";
    // Erlaubt ISO-Datum oder Jahr-Monat-String
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    return `${MONTHS_DE[d.getMonth()]} ${d.getFullYear()}`;
}
